import { Capacitor } from '@capacitor/core';
import { Filesystem, Directory } from '@capacitor/filesystem';
import { Share } from '@capacitor/share';

const blobToBase64 = (blob) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onerror = reject;
    reader.onload = () => {
      const result = String(reader.result);
      const base64 = result.split(',')[1];
      resolve(base64);
    };
    reader.readAsDataURL(blob);
  });
};

export const downloadPDF = async (doc, filename, options = {}) => {
  const { title = 'PDF', text = 'Documento pronto' } = options;
  try {
    const pdfBlob = doc.output('blob');
    const platform = Capacitor.getPlatform();

    if (platform === 'android') {
      const base64 = await blobToBase64(pdfBlob);
      // Directory.Cache non richiede permessi su nessuna versione Android
      const writeResult = await Filesystem.writeFile({
        path: filename,
        data: base64,
        directory: Directory.Cache,
        recursive: true,
      });

      // Prova FileOpener se disponibile
      try {
        const fileOpener = Capacitor.Plugins?.FileOpener;
        if (fileOpener?.open) {
          await fileOpener.open({
            filePath: writeResult.uri,
            contentType: 'application/pdf',
          });
          return;
        }
      } catch (openError) {
        console.error('Errore FileOpener Android:', openError);
      }

      // Usa Share API: Capacitor gestisce la conversione in content:// URI tramite FileProvider
      // Non passare text per evitare intent misto text/plain + application/pdf
      await Share.share({
        title,
        url: writeResult.uri,
        dialogTitle: title,
      });
      return;
    }

    if (platform === 'ios') {
      await Filesystem.requestPermissions();
      const base64 = await blobToBase64(pdfBlob);
      const writeResult = await Filesystem.writeFile({
        path: filename,
        data: base64,
        directory: Directory.Documents,
      });
      await Share.share({
        title,
        text,
        url: writeResult.uri,
      });
      return;
    }

    if (navigator.share && navigator.canShare) {
      const file = new File([pdfBlob], filename, { type: 'application/pdf' });
      if (navigator.canShare({ files: [file] })) {
        await navigator.share({ title, text, files: [file] });
        return;
      }
    }

    const url = URL.createObjectURL(pdfBlob);
    const newWindow = window.open(url, '_blank');
    if (!newWindow) {
      downloadDirect(pdfBlob, filename);
    }
    setTimeout(() => URL.revokeObjectURL(url), 1000);
  } catch (error) {
    console.error('Errore nel download del PDF:', error);
    // Fallback
    try {
      const pdfBlob = doc.output('blob');
      downloadDirect(pdfBlob, filename);
    } catch (fallbackError) {
      console.error('Errore nel fallback:', fallbackError);
    }
  }
};

// Fallback: scarica direttamente tramite blob
const downloadDirect = (pdfBlob, filename) => {
  try {
    const url = URL.createObjectURL(pdfBlob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    link.click();
    
    // Cleanup
    setTimeout(() => URL.revokeObjectURL(url), 100);
  } catch (error) {
    console.error('Errore nel fallback:', error);
  }
};
